const data = {
  HivKitCode: "tokens",
  CovidKitCode: "covid19",
  InstiKitCode: "insti",
  CommunityLinkProdURL: "https://www.community-link.health",
  CommunityLinkDevURL: "https://cl-dshbrd.map-test.plazus.com",
}

export default data;